import { createFileRoute } from '@tanstack/react-router';
import { Typography, Paper } from '@mui/material';

export const Route = createFileRoute('/__auth/signatures/$id/history')({
    component: EnvelopeHistoryRoute,
});

function EnvelopeHistoryRoute() {
    return (
        <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>Histórico</Typography>
            <Typography variant="body2" color="text.secondary">O histórico do fluxo de assinaturas será listado aqui.</Typography>
        </Paper>
    );
}
